import script from "./AdminRoles.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminRoles.vue?vue&type=script&setup=true&lang=ts"

import "./AdminRoles.vue?vue&type=style&index=0&id=135a49ea&lang=scss&scoped=true"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-135a49ea"]])

export default __exports__